export function camelCaseToSpaced(phrase: string): string {
  return phrase
    .replace(/([A-Z])/g, ' $1') // Add a space before each uppercase character
    .toLowerCase();
}